import { render, staticRenderFns } from "./CMCourseRow.vue?vue&type=template&id=f94685ea&scoped=true&lang=pug"
import script from "./CMCourseRow.vue?vue&type=script&lang=js"
export * from "./CMCourseRow.vue?vue&type=script&lang=js"
import style0 from "./CMCourseRow.vue?vue&type=style&index=0&id=f94685ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94685ea",
  null
  
)

export default component.exports